import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import ToggleBar from "components/ToggleBar";
import { persistTogglesAction } from "data/actions";
import { createSelector } from "reselect";
import { produce } from "immer";

const selectTogglesFromStore = (state, name) => state.toggles[name];
const selectTogglesFromProps = (_, __, togglesFromProps) => togglesFromProps;

const makeSelectToggles = () => createSelector(
    [selectTogglesFromStore, selectTogglesFromProps],
    (togglesFromStore, togglesFromProps) => {
        return produce(togglesFromProps, (draft) => {
            draft.forEach((toggle) => {
                toggle.count = togglesFromStore?.counts?.[toggle.value] ?? 0;
                toggle.status = togglesFromStore?.status?.[toggle.value] ?? null;
            });
        });
    }
);

const ToggleBarContainer = ({ isMultiple, name, toggles: togglesFromProps }) => {
    const dispatch = useDispatch();
    const selectTogglesMemoized = useCallback(makeSelectToggles(), []);
    const toggles = useSelector((state) => selectTogglesMemoized(state, name, togglesFromProps));

    const handleClick = useCallback(
        (item) => {
            const newToggles = produce(toggles, (draft) => {
                draft.forEach((toggle) => {
                    if (!isMultiple) toggle.isSelected = false;
                    if (toggle.value === item.value) {
                        toggle.isSelected = !toggle.isSelected;
                    }
                });
                // if none selected preselect first one
                /* istanbul ignore else */
                if (draft.every((toggle) => !toggle.isSelected)) {
                    draft[0].isSelected = true;
                }
            });
            dispatch(persistTogglesAction(name, newToggles));
        },
        [name, toggles, isMultiple, dispatch]
    );

    return (
        <ToggleBar
            name={name}
            isMultiple={isMultiple}
            toggles={toggles}
            onClick={handleClick}
        />
    );
};

export default ToggleBarContainer;
